<ng-container *transloco="let t">
  <div class="admin-card">
    <app-competitor-table [competitors]="competitors" [genders]="genders" [race]="race" [showLoadMoreButton]="true"
                          [applicationFormSettings]="applicationFormSettings" [countries]="countries" [event]="eventItem"
                          [raceSettings]="raceSettings" [isAdmin]="true" [languages]="languages" [raceAdditionalPricingItems]="raceAdditionalItems"
                          [raceCommercialItems]="raceCommercialItems" (refreshCounters)="onRefreshCounters()" [allowOnlyRaceView]="true"
                          (filterChange)="handleFilterChange($event)">
      <div slot="competitorTableAdminLeadingWidgets">
        <div class="ms-2">
          <app-rounded-button [label]="t('race.management.competitors.register')" (onClick)="onRegister()"
                              [isDisabled]="!isRaceRegistrationEnabled()" [btnClass]="'rounded-button--solid'"><i
            class="bi bi-plus-circle pe-2"></i></app-rounded-button>
        </div>
      </div>
      <div slot="competitorTableAdminTrailingWidgets">
        <app-admin-actions-header [isPdfVisible]="false" (onExportToXls)="downloadCompetitorsListForRace('xlsx')">
          <div slot="trailingWidgets">
            <div
              class="d-inline-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <div class="pb-3 pe-2 pb-xl-0">
                <app-rounded-button [label]="t('race.management.competitors.import')"
                                    [btnClass]="'rounded-button--button-black-solid'" [isDisabled]="!isRaceRegistrationEnabled()"
                                    (onClick)="openImportModal()">
                  <i class="bi bi-file-arrow-up pe-2"></i>
                </app-rounded-button>
              </div>
              @if(applicationFormSettings?.chipNumberRegistrationDisplayFlag &&
              applicationFormSettings?.chipNumberRegistrationDisplayFlag !== RegistrationDisplayFlags.NOT_USED) {
              <div class="pe-2">
                <app-rounded-button [label]="t('race.management.competitors.assign.chip.numbers')"
                                    [btnClass]="'rounded-button--button-black-solid'"
                                    (onClick)="assignChipNumber()">
                  <i class="bi bi-list-ol pe-2"></i>
                </app-rounded-button>
              </div>
              }
            </div>
          </div>
        </app-admin-actions-header>
      </div>
    </app-competitor-table>
    @if (showFabButton && (competitors?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>
</ng-container>
